import { useCallback, useMemo, useState } from 'react';
import { ScheduleRequest } from '@weave/schema-gen-ts/dist/schemas/schedule/api/v2/api.pb';
import { useModalControl } from '@frontend/design-system';
import { useCheckPaymentsEnabled } from '../../../../../../hooks/use-check-payments-enabled';
import { ScheduleRequestModalContextType } from '../Context/ScheduleRequestModalContext';

export const useScheduleRequestModalContextValue = <T extends ScheduleRequest = ScheduleRequest>({
  refetchScheduleRequestList,
}: {
  refetchScheduleRequestList: () => void;
}) => {
  const [selectedScheduleRequest, setSelectedScheduleRequest] = useState<T | null>(null);

  const scheduleRequestModalProps = useModalControl({
    onClose: () => {
      setTimeout(() => {
        setSelectedScheduleRequest(null);
      }, 200); // Delay to allow modal's exit animation to finish
    },
  });
  const { isPaymentsEnabled } = useCheckPaymentsEnabled(selectedScheduleRequest?.locationId);

  const handleCloseScheduleRequestModal = useCallback(() => {
    scheduleRequestModalProps.closeModal();
  }, [scheduleRequestModalProps]);

  const scheduleRequestModalContextValue = useMemo<ScheduleRequestModalContextType>(
    () => ({
      scheduleRequestModalProps,
      selectedScheduleRequest: selectedScheduleRequest as T,
      handleCloseScheduleRequestModal,
      refetchScheduleRequestList,
      isPaymentsEnabled,
    }),
    [
      selectedScheduleRequest,
      refetchScheduleRequestList,
      isPaymentsEnabled,
      handleCloseScheduleRequestModal,
      scheduleRequestModalProps,
    ]
  );

  return {
    selectedScheduleRequest,
    setSelectedScheduleRequest,
    scheduleRequestModalContextValue,
    isPaymentsEnabled,
  };
};
